import script from "./dashboard-overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-overview.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard-overview.vue?vue&type=style&index=0&id=448c3234&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448c3234"]])

export default __exports__